export default {
  opponentRank: {
    rankSummary: "Classé {{rank}} en {{marketName}}",
    feedSubtitle: "Classement DEF de {{team}}",
  },
};
